var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerText"},[_vm._v(_vm._s(_vm.footerText))])
}
var staticRenderFns = []

export { render, staticRenderFns }